module.exports = __webpack_public_path__ + "img/symbol_5.975dd68e.png";